<template>
  <div class="home">
    <!-- 头部 -->
    <div class="edit-header" @contextmenu="handleCloseMenu">
      <div class="go-back" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
        <span class="go-back-title">{{ screenConfig.panelName }}</span>
      </div>
      <div class="edit-components">
        <div v-for="(item,i) in COMPONENT_LIST" :key="i" class="components-category">
          <span class="components-category-title" @mouseenter="handleMouseEnter(i)">{{ item.categoryName }}</span>
          <div :ref="`componentBox${i}`" class="component-hover-box" :class="isDragOut ? 'drag-out':''" @dragstart="handleDragStart" @dragend="handleDragEnd">
            <div
              v-for="(component,idx) in item.components"
              :key="idx"
              draggable
              :data-component-name="component.chartComponent"
              class="components-select-item"
              style="background-color:transparent"
              @click="handleAddComponent(component,i)">
              <div :style="{background: `url(${component.templateImg}) center center no-repeat`,backgroundSize: 'cover'}" alt="" class="components-select-item-img" style="background-color:transparent"></div>
              <p class="components-select-item-title" style="background-color:transparent">{{ component.boxTitle }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="component-opti">
        <span class="opti-item" @click="handlePreview">预览</span>
        <span class="opti-item" @click="handleViewScreen">查看大屏</span>
        <span class="opti-item" @click="onDeactivated()">大屏设置</span>
        <el-button type="primary" class="opti-item" @click="handleSaveScreen">保存</el-button>
      </div>
    </div>
    <div v-loading="loading" class="drag-main">
      <div class="drag-main-wrap">
        <!-- 画布 -->
        <div
          ref="dragCanvasContainer"
          class="drag-main-container"
          @mousedown="handleDragContainerClick">
          <div id="dragCanvasWrap" ref="dragCanvasWrap" class="drag-canvas-wrap">
            <div
              id="dragCanvas"
              class="drag-canvas"
              :style="{
                transformOrigin: '0 0',
                width: screenConfig.panelWidth +'px',
                height: screenConfig.panelHeight + 'px',
                background: screenConfig.backgroundType === 1 ? screenConfig.background : '',
                cursor: canvasDrag ? 'grab !important ':'',
                transformOrigin: 'top left',
                transform: `scale(${screenConfig.panelScale}%,${screenConfig.panelScale}%)`,
              }"
              @drop="handleDropEnd"
              @dragover="handleDragOver"
              @mouseenter="handleCanvasMouseEnter"
              @mouseleave="handleCanvasMouseLeave">
              <!-- 背景图 -->
              <img
                v-if="screenConfig.backgroundType !==1"
                class="canvas-background"
                :src="screenBgImgUrl"
                alt="">

              <vue-draggable-resizable
                v-for="(item,index) in screenConfig.chartViews"
                :key="item.addSn"
                :ref="`draggableRef${index}`"
                :lock-aspect-ratio="item.chartComponentType==='SignName'?true:false"
                class="drag-item-box"
                :class="activeComponentList.map(bar => bar.addSn).includes(item.addSn) ? 'is-selected':''"
                :parent="true"
                :active="item.active"
                :x="item.chartX"
                :y="item.chartY"
                :w="item.chartWidth"
                :h="item.chartHeight"
                :prevent-deactivation="false"
                :snap="true"
                :snap-tolerance="10"
                :draggable="item.draggable"
                :drag-cancel="'.drag-cancel'"
                :z="item.sort"
                @activated="onActivated(index,item)"
                @deactivated="onDeactivated(index,item)"
                @refLineParams="getRefLineParams"
                @dragging="(x,y) => onDrag(index,item,x,y)"
                @dragstop="(x,y) => onDragStop(index,item,x,y)"
                @resizing="(x,y,w,h) => onResize(index,item,x,y,w,h)"
                @resizestop="(x,y,w,h) => onResizeStop(index,item,x,y,w,h)"
                @contextmenu="handleOpenMenu($event, item, index)">
                <!-- 各个组件 -->
                <component
                  :is="item.chartComponentType"
                  :ref="`chartComponent${index}`"
                  :config="item"
                  :component-type="item.chartComponent"
                  :global-config="screenConfig"
                  :filter-params="filterParams"
                  @filterChange="handleFilterChange" />
                <!-- 辅助操作 -->
                <div v-show="item.active" class="drag-item-operation-box" :style="{height:item.chartHeight +'px' }">
                  <Icon v-if="!['text','richText','borderBlock','signName'].includes(item.chartComponent)" icon="zu34024" class="drag-item-operation-box-icon" @click.native="handelManageData"></Icon>
                  <Icon icon="zu34025" class="drag-item-operation-box-icon" @click.native="handleDeleteItem(index,item)"></Icon>
                  <!-- 宽高 -->
                  <div class="drag-item-operation-box-size">{{ (+item.chartWidth).toFixed(0) }}×{{ (+item.chartHeight).toFixed(0) }}</div>
                </div>
              </vue-draggable-resizable>
              <!--辅助线-->
              <span
                v-for="(item,i) in vLine"
                v-show="item.display"
                :key="i + 200000"
                class="ref-line v-line"
                :style="{ left: item.position, top: item.origin, height: item.lineLength}" />
              <span
                v-for="(item,i) in hLine"
                v-show="item.display"
                :key="i + 300000"
                class="ref-line h-line"
                :style="{ top: item.position, left: item.origin, width: item.lineLength}" />
              <!--辅助线END-->

              <!-- 空格拖拽时的蒙版 -->
              <div
                v-show="canvasDrag"
                class="canvas-drag-mask"
                :class="canvasMouseDown ? 'mouse-down':''"
                @mousedown="handleMouseDown"
                @mousemove="handleMouseMove"
                @mouseup="handleMouseUp" />
            </div>
            <!-- <div style="width: 100%;height: 20px;"></div> -->
          </div>
        </div>
        <div class="canvas-tool-bar">
          <span class="scale-number">{{ screenConfig.panelScale +'%' }}</span>
          <i class="icon el-icon-remove-outline" @click="handleScaleReduce" />
          <el-slider
            v-model="screenConfig.panelScale"
            :max="200"
            :min="20"
            :format-tooltip="formatTooltip"
            :marks="{100:''}">
          </el-slider>
          <i class="icon el-icon-circle-plus-outline" @click="handleScaleIncrease" />
        </div>
      </div>
      <!-- 组件设置、大屏设置 -->
      <PaneConfig
        ref="paneConfig"
        class="config-pane"
        :relate-map="relateMap"
        :screen-config="{
          ...screenConfig,
          chartViews: undefined
        }"
        :map-component-list="mapComponentList"
        :current-component="currentComponent"
        :screen-data="screenData"
        @closeRightMenu="handleCloseMenu" />
      <!-- 预览 -->
      <el-dialog
        v-loading="previewLoading"
        :visible="previewDialogShow"
        class="preview-dialog"
        :destroy-on-close="false"
        @close="previewDialogShow = false">
        <img id="previewContainer" class="preview-container" />
      </el-dialog>
      <!-- 鼠标右键菜单 -->
      <ul v-show="rightMenuVisible" :style="{left:rightMenuLeft+'px',top:rightMenuTop+'px'}" class="contextmenu">
        <li @click="handleCompToTop">置于顶层</li>
        <li @click="handleCompToGround">置于底层</li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ImageBlock from '@/components/charts/image.vue'
import TextBlock from '@/components/charts/text.vue'
import MapChart from '@/components/charts/mapChart.vue'
import PieChart from '@/components/charts/pieChart.vue'
import LineChart from '@/components/charts/lineChart.vue'
import BarChart from '@/components/charts/barChart.vue'
import Number from '@/components/charts/number/number.vue'
import IndependentNumber from '@/components/charts/number/independentNumber.vue'
import Gauge from '@/components/charts/number/gauge.vue'
import ScrollTable from '@/components/charts/table/scrollTable.vue'
import PaneConfig from './components/paneConfig.vue'
import Rank from '@/components/charts/rank.vue'
import RichTextBlock from '@/components/charts/material/richText.vue'
import BorderBlock from '@/components/charts/material/borderBlock.vue'
import FilterBlock from '@/components/charts/material/filterBlock.vue'
import HeatMapChart from '@/components/charts/heatMap.vue'
import SignName from '@/components/charts/material/signName.vue'

import { INIT_CHART_DATA, COMPONENT_LIST } from '@/utils/defaultComponentConfig'
import domtoimage from 'dom-to-image'
import {
  imgURLtoBase64,
  dataURLtoFile,
  randomString,
} from '@/utils/common'
import {
  uploadFile,
} from '@/utils/upload'
import { defaultFilterDate } from './data'
import {
  saveScreenApi,
  getScreenDataApi,
  getDataIndicatorApi,
} from './fetch'
import { needIndexComponent } from './funcs'

let self = null
//  keyCode
const DELETE_KEY = 46 // delete
const COPY_KEY = 67 // c
const PASTE_KEY = 86 // v
const BACKSPACE = 8 // backspace
const DIRECTION_LEFT = 37
const DIRECTION_UP = 38
const DIRECTION_RIGHT = 39
const DIRECTION_DOWN = 40

export default {
  name: 'ScreenEdit',
  layout: () => {
    return 'empty'
  },
  components: {
    ImageBlock,
    PaneConfig, // 侧边配置栏
    TextBlock,
    MapChart, // 地图
    PieChart, // 饼图
    LineChart, // 折线图
    BarChart, // 垂直柱状图 / 水平柱状图
    Number, // 纯数字
    IndependentNumber, // 独立数字
    Gauge, // 仪表盘
    ScrollTable, // 滚动列表
    Rank, // 排行榜
    RichTextBlock, // 富文本编辑
    BorderBlock, // 边框
    FilterBlock, // 筛选
    HeatMapChart, // 热力图
    SignName, // 署名
  },
  data () {
    return {
      // 最大sort值
      maxSort: undefined,
      // 最小sort值
      minSort: undefined,
      // 空格拖动参数
      canvasDrag: false,
      canvasMouseDown: false,
      canvasStartX: 0,
      canvasStartY: 0,
      scrollTop: 0,
      scrollLeft: 0,
      // 空格拖动参数 END
      addSn: '1_' + randomString(), // 添加顺序
      loading: false,
      isDragOut: false,
      screenBgImgUrl: '',
      previewDialogShow: false,
      previewLoading: false,
      COMPONENT_LIST,
      currentComponent: null,
      dragComponentName: undefined,
      // 收集地图组件，供关联下拉使用
      mapComponentList: [],
      // 地图与其他组件关联关系
      relateMap: {},
      // 大屏配置
      screenConfig: {
        // 全局设置

        // 尺寸
        panelProportion: '16:9',
        panelWidth: 1920,
        panelHeight: 1080,
        panelScale: 100,

        // 大屏名称
        panelName: '',

        // 配色
        chartColors: 'default', // 全局组件配色
        // 背景颜色  注意回填
        backgroundType: 1, // color 1 || template 2
        background: '#071228', // 背景颜色 or 模版图片链接
        // 交互
        jumpPanelSn: '', // 是否自动跳转，记录跳转大屏id
        jumpDelaySecond: null, // 延迟多少秒跳转另外一个大屏

        // 大屏内包含的组件
        chartViews: [],

        // 模板快照
        panelThumbnail: '',
      },
      // 对齐辅助线
      vLine: [],
      hLine: [],
      currentComponentIndex: null,
      isShowManageData: false,
      screenId: this.$route.params.id, // 大屏id
      body: null,
      copyComponentItem: {},
      filterParams: {
        startTime: defaultFilterDate.startTime,
        endTime: defaultFilterDate.endTime,
        panelSn: this.$route.params.id,
      },
      filterParamsClone: {},
      // 鼠标右键菜单相关
      rightMenuVisible: false,
      rightClickComp: undefined,
      rightMenuTop: 0,
      rightMenuLeft: 0,
      activeComponentList: [],
      activeComponentPosition: [],
      assistLineParams: {},
      draggingItem: null,
      draggingPosition: {},
    }
  },
  computed: {
    screenSize () {
      return this.screenConfig.panelWidth + '' + this.screenConfig.panelHeight
    },
    screenBg () {
      if (this.screenConfig.backgroundType === 1) {
        return ''
      } else {
        return this.screenConfig.background
      }
    },
    screenData () {
      return _.cloneDeep(this.screenConfig.chartViews)
    },
  },
  watch: {
    async screenBg (val) {
      // 大屏背景图片转 Base64 格式，在预览时，使用canvas捕获当前大屏快照则不会报错
      this.screenBgImgUrl = await imgURLtoBase64(val)
    },
    screenSize (val) {
      setTimeout(() => {
        const length = this.screenConfig.chartViews.length
        for (let i = 0; i < length; i++) {
          try {
            this.$refs[`draggableRef${i}`][0].checkParentSize()
            // this.$refs[`draggableRef${i}`][0].updateDragLimit()
          } catch (e) {
          }
        }
      }, 100)
    },
    rightMenuVisible (newVal) {
      if (newVal) {
        document.addEventListener('click', this.handleCloseMenu)
      } else {
        document.removeEventListener('click', this.handleCloseMenu)
      }
    },
  },
  created () {
    this.currentComponent = this.screenConfig
    if (this.screenId) {
      this.getScreenDetail()
    }
    self = this
  },
  mounted () {
    document.addEventListener('keydown', this.keydownHandle)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.keydownHandle)
    document.removeEventListener('click', this.handleCloseMenu)
  },
  methods: {
    handleViewScreen () {
      window.open(`/screen/view/${this.screenId}`)
    },
    //  获取大屏数据
    async getScreenDetail () {
      try {
        this.loading = true
        const res = await getScreenDataApi(this.screenId)
        let maxSnNum = 0
        let curSnNum = (this.addSn + '').split('_')[0]
        let maxSort = 10
        let minSort = 10
        const promiseList = []
        res.chartViews.forEach(async item => {
          if (!item.addSn) {
            item.addSn = curSnNum++ + '_' + randomString()
          }
          const itemSnNum = (item.addSn + '').split('_')[0]
          maxSnNum = itemSnNum > maxSnNum ? itemSnNum : maxSnNum
          maxSort = item.sort > maxSort ? item.sort : maxSort
          minSort = item.sort < minSort ? item.sort : minSort
          //  设置 active 、draggable 属性
          this.$set(item, 'active', false)
          this.$set(item, 'draggable', true)
          // JSON字符串转换
          item.chartSet = JSON.parse(item.chartSet)
          item.chartViewData.initData = JSON.parse(item.chartViewData.initData)
          // 使用指标库的组件处理指标数据
          if (item.chartSet?.dataSource === 'indicatorLib') {
            const parseData = JSON.parse(item.chartViewData.chartData)
            const chartData = Object.prototype.toString.call(parseData) === '[object Object]' ? parseData : {}
            item.chartViewData = {
              ...item.chartViewData,
              ...chartData,
            }
            item.chartViewData.chartData = ''
          } else {
            item.chartViewData.chartData = JSON.parse(item.chartViewData.chartData)
          }
          // 可以使用指标库的组件获取指标列表
          if (needIndexComponent(item.chartComponent)) {
            // await this.setComponentIndexSelectList(item)
            promiseList.push(this.setComponentIndexSelectList(item))
          }
          // 兼容独立数字组件和边框组件老数据
          if (item.chartComponentType === 'IndependentNumber' && !item.chartSet.borderStyle?.numberBorderType) {
            item.chartSet.borderStyle.numberBorderType = 1
          }
          if (item.chartComponentType === 'BorderBlock' && !item.chartSet.chartStyle?.borderType) {
            item.chartSet.chartStyle.borderType = 1
          }
        })
        if (promiseList?.length !== 0) {
          await Promise.all(promiseList)
        }
        // 设置当前页面的最大SN
        this.addSn = +maxSnNum + 1 + '_' + randomString()
        this.maxSort = maxSort
        this.minSort = minSort
        if (res.backgroundType === 1) {
          res.background = res.backgroundColor
        } else {
          res.background = res.backgroundTemplate
        }
        res.panelScale = 100
        // 赋值
        this.screenConfig = res
        this.currentComponent = res
        // 组件数据收集分析
        this.screenConfig.chartViews.forEach((item) => {
          // 收集地图组件，供关联下拉使用
          if (item.chartComponent === 'mapChart') {
            this.mapComponentList.push(item)
            if (!item.chartViewData.initDataFlag) {
              item.chartSet.chartStyle.mapLocalBak = item.chartSet.chartStyle.map.join('/')
            }
          }
          /**
           * 将地图与其他组件的关联关系映射出来
           * { map_addSn: [line_addSn,scrollTable_addSn] }
           */
          if (item.chartSet.chartStyle.isLinkMap && item.chartSet.chartStyle.linkMap) {
            if (this.relateMap[item.chartSet.chartStyle.linkMap]) {
              this.relateMap[item.chartSet.chartStyle.linkMap].push(item.addSn)
            } else {
              this.relateMap[item.chartSet.chartStyle.linkMap] = [item.addSn]
            }
          }
        })
        this.$nextTick(() => {
          // 回填组件数据
          this.handleFilterChange(this.filterParams)
        })
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    formatTooltip (val) {
      return val + '%'
    },
    // 辅助线回调事件
    getRefLineParams (params) {
      const { vLine, hLine } = params
      const a = vLine.find(bar => bar.display)
      const b = hLine.find(bar => bar.display)
      if (a || b) {
        this.assistLineParams = params
        this.refLineThrottle()
      } else {
        this.assistLineParams = {
          vLine: [],
          hLine: [],
        }
        this.refLineDebounce()
      }
    },
    refLineDebounce: _.debounce(() => {
      const { vLine, hLine } = self.assistLineParams
      self.vLine = vLine
      self.hLine = hLine
    }, 30),
    refLineThrottle: _.throttle(() => {
      const { vLine, hLine } = self.assistLineParams
      self.vLine = vLine
      self.hLine = hLine
    }, 100),

    onResize: _.throttle((index, item, x, y, w, h) => {
      item.chartWidth = w
      item.chartHeight = h
    }, 100),

    onResizeStop (index, item, x, y, w, h) {
      try {
        item.chartWidth = w
        item.chartHeight = h
        this.$refs[`draggableRef${index}`][0].$children[0].chartResize()
      } catch (e) {
        // ignore error
      }
    },
    handleDragStart (event) {
      this.dragComponentName = event.target.dataset.componentName
    },
    handleDragEnd () {
      this.isDragOut = false
    },

    onDrag (index, item, x, y) {
      if (this.activeComponentList.length) {
        this.draggingItem = item
        this.draggingPosition = {
          x,
          y,
        }
        const draggableComponentList = []
        Object.keys(this.$refs).forEach(key => {
          if (key.indexOf('draggableRef') !== -1) {
            draggableComponentList.push(this.$refs[key][0])
          }
        })
        const offset = this.activeComponentPosition.find(foo => foo.componentSn === item.addSn)
        const offX = x - offset.x
        const offY = y - offset.y
        this.activeComponentList.forEach(bar => {
          const refItem = draggableComponentList.find(item => item.$children.find(foo => foo.config && foo.config.addSn === bar.addSn))
          const cur = this.activeComponentPosition.find(foo => foo.componentSn === bar.addSn)
          refItem.$el.style.transform = `translate(${offX + cur.x}px,${offY + cur.y}px)`
        })
        this.setPosition()
      }
    },
    setPosition: _.debounce(() => {
      const offset = self.activeComponentPosition.find(foo => foo.componentSn === self.draggingItem.addSn)
      const offX = self.draggingPosition.x - offset.x
      const offY = self.draggingPosition.y - offset.y
      self.activeComponentList.forEach(bar => {
        const cur = self.activeComponentPosition.find(foo => foo.componentSn === bar.addSn)
        bar.chartX = offX + cur.x
        bar.chartY = offY + cur.y
      })
    }, 30),

    // 移动位置
    onDragStop (index, item, x, y) {
      item.chartX = x
      item.chartY = y
    },
    // 点击添加到画布
    handleAddComponent (item, parenTIndex) {
      this.dragComponentName = item.chartComponent
      this.$refs[`componentBox${parenTIndex}`][0].style.visibility = 'hidden'

      if (this.dragComponentName) {
        const allComponents = this.COMPONENT_LIST.map(bar => bar.components).flat()
        const component = JSON.parse(JSON.stringify(allComponents.find(bar => bar.chartComponent === this.dragComponentName)))
        // 获取当前屏幕滚动条位置，设置组件视图中心位置
        const scrollTopY = this.$refs.dragCanvasContainer.scrollTop
        const scrollTopX = this.$refs.dragCanvasContainer.scrollLeft
        const wrapHeight = this.$refs.dragCanvasContainer.offsetHeight
        const wrapWidth = this.$refs.dragCanvasContainer.offsetWidth
        component.chartY = scrollTopY + 0.3 * wrapHeight
        component.chartX = scrollTopX + 0.35 * wrapWidth
        this.addComponentToData(component)
      }
    },
    // 组件激活
    onActivated (index, item) {
      this.currentComponentIndex = index
      this.screenConfig.chartViews.forEach(bar => { bar.active = false })
      item.active = true
      this.currentComponent = item

      if (item.chartComponent === 'richText') {
        this.currentRichText = this.$refs['draggableRef' + index][0].$children.find(bar => bar.editor)
      }
    },
    // 组件非激活
    onDeactivated (index, item) {
      this.screenConfig.chartViews.forEach((item) => {
        item.active = false
      })
      this.currentComponent = this.screenConfig
      this.currentComponentIndex = null
    },

    // 将组件拖动到画布
    handleDropEnd (e) {
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.clearData()
      this.isDragOut = false
      const rectInfo = document
        .getElementById('dragCanvas')
        .getBoundingClientRect()
      if (this.dragComponentName) {
        const allComponents = this.COMPONENT_LIST.map(bar => bar.components).flat()
        const component = JSON.parse(JSON.stringify(allComponents.find(bar => bar.chartComponent === this.dragComponentName)))
        component.chartY = +e.clientY - +rectInfo.y
        component.chartX = +e.clientX - +rectInfo.x
        this.addComponentToData(component)
      }
    },

    // 移动中
    handleDragOver (e) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
      this.isDragOut = true
    },

    // 删除
    handleDeleteItem (index, item) {
      if (!item.chartViewData.initDataFlag || item.chartComponent === 'richText') {
        this.$confirm('确定删除该组件吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.screenConfig.chartViews.splice(index, 1)
          // 组件设置 修改为大屏设置
          this.currentComponent = this.screenConfig
        }).catch(() => {
        })
      } else {
        this.screenConfig.chartViews.splice(index, 1)
        // 组件设置 修改为大屏设置
        this.currentComponent = this.screenConfig
      }
      if (item.chartComponent === 'mapChart') {
        const index = this.mapComponentList.findIndex(bar => bar.addSn === item.addSn)
        this.mapComponentList.splice(index, 1)
        const list = this.screenConfig.chartViews.filter(bar => bar.chartSet.chartStyle?.linkMap === item.addSn)
        list.forEach(bar => {
          bar.chartSet.chartStyle.linkMap = undefined
          bar.chartSet.chartStyle.isLinkMap = false
          bar.chartViewData.chartData = _.cloneDeep(INIT_CHART_DATA)
        })
      }
    },
    // 保存大屏
    async handleSaveScreen () {
      // 保存前将所有组件置为非选中，以免截图有虚线框
      this.onDeactivated()
      // 清除多选，避免截图出现多选时的样式
      this.clearMultiSelect()
      await this.$nextTick()
      try {
        this.loading = true
        const params = _.cloneDeep(this.screenConfig)
        // 处理大屏的背景数据
        if (params.backgroundType === 1) {
          params.backgroundColor = params.background
        } else {
          params.backgroundTemplate = params.background
        }
        // 各个组件的 样式 转JSON 、判断各组件是否设置数据指标
        if (params.chartViews?.length !== 0) {
          params.chartViews.forEach(item => {
          // 删除数据指标列表
          item?.dataIndicatorList && delete item.dataIndicatorList
          const dataSource = item.chartSet?.dataSource
          item.chartSet = JSON.stringify(item.chartSet)
          item.chartViewData.initData = JSON.stringify(item.chartViewData.initData)
          if (needIndexComponent(item.chartComponent) && dataSource === 'indicatorLib') {
            item.chartViewData.selectedIndicatorList.forEach(foo => {
              if (!foo.dataIndicator) {
                throw new Error(`${item.chartTitle}未设置数据`)
              }
            })
            const dataParams = {
              selectedIndicatorList: item.chartViewData.selectedIndicatorList,
              detailIndicator: item.chartViewData.detailIndicator,
              showIndicator: item.chartViewData.showIndicator,
            }
            item.chartViewData.chartData = JSON.stringify(dataParams)
          } else {
            item.chartViewData.chartData = JSON.stringify(item.chartViewData.chartData)
          }
          })
        }
        // 大屏截图
        const screenSnapshotUrl = await this.getScreenSnapshotOssUrl()
        // const screenSnapshotUrl = ''
        params.panelThumbnail = screenSnapshotUrl
        // 保存后，返回大屏ID，以及新增组件id，需要将id添加进数据，不然会导致在当前页面编辑组件数据报错，找不到组件id
        const res = await saveScreenApi(params)
        this.screenConfig.chartViews.forEach(item => {
          if (!item.id) {
            const curItem = res.panelChartList.find(bar => bar.addSn === item.addSn)
            this.$set(item.chartViewData, 'chartViewId', curItem.id)
            this.$set(item, 'id', curItem.id)
            this.$set(item.chartViewData, 'id', curItem.chartDataId)
          }
        })
        this.$success('保存成功')
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    // 本地新页面预览
    handlePreviewFullScreen () {
      localStorage.setItem('LOCAL_PREVIEW_FULL_SCREEN', JSON.stringify(this.screenConfig))
      window.open('/screen/preview', 'newwindow')
    },

    // 弹窗预览
    async handlePreview () {
      // 清除选中状态
      this.onDeactivated()
      // 清除多选，避免截图出现多选时的样式
      this.clearMultiSelect()
      await this.$nextTick()
      this.previewLoading = true
      this.previewDialogShow = true
      const img = await this.getBase64ScreenSnapShot()
      document.getElementById('previewContainer').src = img
      this.previewLoading = false
    },

    async getScreenSnapshotOssUrl () {
      const imgDataUrl = await this.getBase64ScreenSnapShot()
      const file = dataURLtoFile(imgDataUrl, `screenShot_${this.screenConfig.id || ''}.jpg`)
      return uploadFile(file)
    },

    // 获取屏幕快照，返回 Base64 格式
    getBase64ScreenSnapShot () {
      // return is a Promise
      return domtoimage.toJpeg(document.getElementById('dragCanvas'), {
        quality: 0.95,
        height: this.screenConfig.panelHeight * this.screenConfig.panelScale * 0.01,
        width: this.screenConfig.panelWidth * this.screenConfig.panelScale * 0.01,
        bgcolor: this.screenConfig.backgroundType === 1 ? this.screenConfig.backgroundColor : undefined, // 纯色背景
      })
    },

    handleBack () {
      this.$confirm('当前大屏配置尚未保存确定返回吗？', '提示', {
        confirmButtonText: '保存并返回',
        cancelButtonText: '返回',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
      }).then(async () => {
        await this.handleSaveScreen()
        this.$router.push({ path: '/screen' })
      }).catch((e) => {
        if (e === 'cancel') {
          this.$router.push({ path: '/screen' })
        }
      })
    },
    handelManageData () {
      this.$refs.paneConfig.handleManageData()
    },
    keydownHandle (e) {
      if (this.$refs.paneConfig.dialogVisible || (e.target && this.currentComponent.chartViews)) {
        return
      }
      const keyCode = e.keyCode
      const ctrl = e.ctrlKey || e.metaKey
      let itemIndex = null
      switch (true) {
        case keyCode === DELETE_KEY || keyCode === BACKSPACE:
          if (this.currentComponent.chartComponent === 'richText' && !this.currentComponent.draggable) {
            return
          }
          // 获取删除的组件下标
          this.screenConfig.chartViews.forEach((item, index) => {
            if (item.addSn === this.currentComponent.addSn) {
              itemIndex = index
            }
          })
          this.handleDeleteItem(itemIndex, this.currentComponent)
          break
        case keyCode === COPY_KEY && ctrl:
          this.copyComponentItem = _.cloneDeep(this.currentComponent)
          break
        case keyCode === PASTE_KEY && ctrl:
          //  仅黏贴一次，黏贴后随即清空
          if (this.copyComponentItem) {
            const component = _.cloneDeep(this.copyComponentItem)
            component.chartY += 20
            component.chartX += 20
            component.chartTitle += '副本'
            delete component.id
            delete component.chartViewData.id
            delete component.chartViewData.chartViewId
            this.addComponentToData(component)
            this.copyComponentItem = null
          }

          break
        case keyCode === DIRECTION_LEFT :
          if (this.currentComponent.chartComponent === 'richText' && !this.currentComponent.draggable) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          if (this.activeComponentList.length) {
            this.activeComponentList.forEach(item => {
              item.chartX -= 1
            })
          } else {
            this.currentComponent.chartX -= 1
          }

          break
        case keyCode === DIRECTION_UP :
          if (this.currentComponent.chartComponent === 'richText' && !this.currentComponent.draggable) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          if (this.activeComponentList.length) {
            this.activeComponentList.forEach(item => {
              item.chartY -= 1
            })
          } else {
            this.currentComponent.chartY -= 1
          }
          break
        case keyCode === DIRECTION_RIGHT :
          if (this.currentComponent.chartComponent === 'richText' && !this.currentComponent.draggable) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          if (this.activeComponentList.length) {
            this.activeComponentList.forEach(item => {
              item.chartX += 1
            })
          } else {
            this.currentComponent.chartX += 1
          }

          break
        case keyCode === DIRECTION_DOWN :
          if (this.currentComponent.chartComponent === 'richText' && !this.currentComponent.draggable) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          if (this.activeComponentList.length) {
            this.activeComponentList.forEach(item => {
              item.chartY += 1
            })
          } else {
            this.currentComponent.chartY += 1
          }

          break

        default:
          break
      }
    },
    handleMouseEnter (i) {
      this.$refs[`componentBox${i}`][0].style.visibility = 'visible'
    },

    handleMouseDown (e) {
      if (!this.canvasMouseDown) {
        this.canvasMouseDown = true
      }
      this.canvasStartX = e.clientX
      this.canvasStartY = e.clientY
      this.scrollTop = this.$refs.dragCanvasContainer.scrollTop
      this.scrollLeft = this.$refs.dragCanvasContainer.scrollLeft
    },
    handleMouseMove (e) {
      if (this.canvasMouseDown) {
        const offX = this.canvasStartX - e.clientX
        const offY = this.canvasStartY - e.clientY
        this.$refs.dragCanvasContainer.scrollTo({
          top: this.scrollTop + offY,
          left: this.scrollLeft + offX,
          behavior: 'auto',
        })
      }
    },
    handleMouseUp (e) {
      this.canvasMouseDown = false
      this.canvasStartX = 0
      this.canvasStartY = 0
    },

    keydown (e) {
      const activeComp = this.screenConfig.chartViews.find(bar => bar.active)
      if (!activeComp) {
        if (e.keyCode === 32) {
          e.preventDefault()
          if (!this.canvasDrag) { // 空格键
            this.canvasDrag = true
          }
        }
      } else {
        if (e.keyCode === 32) {
          if (activeComp.chartComponent === 'richText') {
            if (activeComp.draggable) {
              e.preventDefault()
              if (!this.canvasDrag) { // 空格键
                this.canvasDrag = true
              }
            }
          } else {
            e.preventDefault()
            if (!this.canvasDrag) { // 空格键
              this.canvasDrag = true
            }
          }
        }
      }
    },
    keyup (e) {
      if (e.keyCode === 32) {
        e.preventDefault()
        this.canvasDrag = false
      }
    },

    handleCanvasMouseEnter (e) {
      window.addEventListener('keydown', this.keydown)
      window.addEventListener('keyup', this.keyup)
    },
    handleCanvasMouseLeave (e) {
      window.removeEventListener('keydown', this.keydown)
      window.removeEventListener('keyup', this.keyup)
      this.canvasDrag = false
      this.handleMouseUp()
    },

    handleDragContainerClick (e) {
      let flag = true
      e.composedPath().forEach(item => {
        if (item.__vue__ && item.__vue__.config && item.__vue__.config.addSn) {
          flag = false
          if (e.ctrlKey) {
            e.preventDefault()
            this.addSelectComponent(item.__vue__.config)
          } else {
            if (!this.activeComponentList.map(bar => bar.addSn).includes(item.__vue__.config.addSn)) {
              this.clearMultiSelect()
            }
          }
          // 加入当前选中的组件
          if (this.activeComponentList.length === 0) {
            e.preventDefault()
            this.addSelectComponent(item.__vue__.config)
          }
        }
      })
      if (flag) this.clearMultiSelect()
    },

    handleScaleReduce () {
      this.screenConfig.panelScale -= 10
    },
    handleScaleIncrease () {
      this.screenConfig.panelScale += 10
    },

    // 清除多选
    clearMultiSelect () {
      this.activeComponentPosition = []
      this.activeComponentList = []
    },
    // 筛选
    handleFilterChange (filterParams) {
      this.filterParams.panelSn = this.$route.params.id
      const keys = filterParams ? Object.keys(filterParams) : []
      if (filterParams) {
        const { startTime, endTime, ...rest } = { ...(this.filterParams ?? {}), ...filterParams }
        this.filterParams = {
          ...rest,
          startTime: startTime || defaultFilterDate.startTime,
          endTime: endTime || defaultFilterDate.endTime,
        }
      }
      this.screenConfig.filterParams = JSON.stringify(this.filterParams)
      // 调用各个组件更新数据方法
      Object.keys(this.$refs).forEach(key => {
        const component = Array.isArray(this.$refs[key]) ? this.$refs[key][0] : {}
        // 如果组件是地图组件，需要更新地图数据
        if (component?.config?.chartComponent === 'mapChart') {
          const { provinceCode, cityCode, regionCode } = this.filterParams
          if (provinceCode || cityCode || regionCode) {
            const mapData = regionCode ? ['100000', provinceCode, cityCode, regionCode] : (cityCode ? ['100000', provinceCode, cityCode] : ['100000', provinceCode])
            component.config.chartSet.chartStyle.map = mapData
          }
        }
        // 更新数据
        if (component?.getChartData && typeof component.getChartData === 'function') {
          component.getChartData(this.filterParams)
        }
        if (component && component.config && component.config.chartComponent === 'filterBlock' && filterParams.addSn && !keys.includes('startTime')) {
          if (component.config.addSn !== filterParams.addSn) {
            component.clearDate()
          }
        }
      })
    },
    // 鼠标右键打开菜单
    handleOpenMenu (e, item, index) {
      /**
       * Mac 系统 使用ctrl + 鼠标左键 = 鼠标右键
       * 根据是否使用 ctrl，来判断是多选还是真实鼠标右键点击
       */
      if (e.ctrlKey) {
        e.preventDefault()
        this.addSelectComponent(item)
        return
      }
      if (!item.active) {
        this.rightMenuVisible = false
        return
      }
      e.preventDefault()
      this.rightClickComp = item
      this.rightMenuTop = e.pageY
      this.rightMenuLeft = e.pageX
      this.rightMenuVisible = true
    },
    addSelectComponent (item) {
      if (!this.activeComponentList.find(bar => (bar.addSn === item.addSn) || (bar.addSn === item?.__vue__?.config.addSn))) {
        this.activeComponentList.push(item)
        this.activeComponentPosition = this.activeComponentList.map(bar => {
          return {
            componentSn: bar.addSn,
            x: bar.chartX,
            y: bar.chartY,
          }
        })
      }
    },
    // 关闭鼠标右键菜单
    handleCloseMenu () {
      this.rightMenuVisible = false
    },
    handleCompToTop () {
      if (this.rightClickComp.sort < this.maxSort) {
        this.rightClickComp.sort = ++this.maxSort
      }
    },
    handleCompToGround () {
      if (this.rightClickComp.sort > this.minSort) {
        if (this.minSort <= 10) {
          this.screenConfig.chartViews
            .filter(bar => bar.addSn !== this.rightClickComp.addSn)
            .forEach(bar => {
              bar.sort = bar.sort + 1
            })
          this.rightClickComp.sort = this.minSort
        } else {
          this.rightClickComp.sort = --this.minSort
        }
      }
    },
    // 将component push 到chartViews
    async addComponentToData (component) {
      component.sort = this.maxSort++
      const itemSnNum = (this.addSn + '').split('_')[0]
      component.addSn = itemSnNum + '_' + randomString()
      if (component.chartComponent === 'mapChart') {
        this.mapComponentList.push(this.screenConfig.chartViews[this.screenConfig.chartViews.length - 1])
      }
      await this.setComponentIndexSelectList(component)
      this.screenConfig.chartViews.push({
        ...component,
      })
    },
    // 设置组件的指标下拉候选项
    async setComponentIndexSelectList (component) {
      component.dataIndicatorList = await getDataIndicatorApi(
        {
          indicatorChart: component.chartComponent,
          indicatorType: 1,
          panelSn: this.screenId,
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.home{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .edit-header{
    background: #000;
    color: #fff;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1000;
    .go-back {
      cursor: pointer;
      &-title {
        display: inline-block;
        width:200px;
      }
    }
    .component-opti {
      padding-left: 88px;
    }
    .edit-components{
      .components-category{
        display: inline-block;
        position: relative;
        padding: 0 20px;
        &-title {
          cursor: default;

        }
        &:hover{
          .component-hover-box{
            display: block !important;
            width: 580px;
            background:#fff;
            padding: 20px;
            line-height: 1em;
            color: #333;
            box-shadow: 6px 6px 12px rgba(0,0,0,0.16);;
          }
        }
        .component-hover-box{
          display: none;
          position: absolute;
          top: 100%;
          left: -256px;
          &.drag-out{
            display: none;
          }
          .components-select-item{
            display: inline-block;
            margin: 0 5px 30px ;
            text-align: center;
            &-img {
              width: 170px;
              height: 110px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
    .component-opti{
      .opti-item{
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
      }
    }
  }
  .drag-main {
    display: flex;
    flex: 1;
    height: calc(100% - 60px);
    border-top: 1px solid #dcdfe6;
    box-sizing: border-box;
    .drag-main-wrap{
      height: 100%;
      width: 0;
      flex: 1;
      margin-bottom: -20px;
      display: flex;
      flex-direction: column;
      .drag-main-container{
        flex: 1;
        overflow: auto;
        height: calc(100% - 30px);
          padding: 20px;
        .drag-canvas-wrap{
          height: 100%;
          .drag-canvas {
            position: relative;
            box-sizing: border-box;
            background-size: auto !important;
            background-size: 100% 100% !important;
            &::before{
              content:'';
              position: absolute;
              height: 20px;
              width: 100%;
              top: 100%;
            }
            &::after{
              content: '';
              position: absolute;
              height: 100%;
              width: 20px;
              left: 100%;
            }
            :deep(.drag-item-box){
              .handle{
                z-index: 999999;
              }
            }
            .drag-item-box{
              border: 1px dashed transparent;
              &.active{
                border: 1px dashed #d6d6d6;
              }
              &.is-selected{
                // background: red;
                border: 1px solid #258aff;
              }
            }
            .screen-title{
              position: absolute;
              width: 100%;
              padding: 10px 35px;
              z-index: 1;
            }
            .canvas-background{
              position: absolute;
              width: 100%;
              height: 100%;
              -webkit-user-drag: none;
              line-height: 63px;
            }
            .drag-item-operation-box{
              font-size: 20px;
              position: absolute;
              right: -25px;
              width: 20px;
              top: 0;
              .drag-item-operation-box-icon{
                display: block;
                cursor: pointer;
                margin-bottom: 5px;
                color: #4e4e4e;
                &:hover{
                  color: #3269ff;
                }
              }
              &-size {
                display: inline-block;
                height: 28px;
                padding: 5px;
                background-color: #e8e8e8;
                font-size: 10px;
                color: #4e4e4e;
                border-radius: 5px;
              }
            }
            .canvas-drag-mask{
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 999999999999;
              cursor: grab;
              &.mouse-down{
                cursor: grabbing;
              }
              &-size {
                position: absolute;
                top: 88%;
                min-width: 64px;
                height: 28px;
                padding: 5px;
                background-color: #e8e8e8;
                font-size: 10px;
                color: #4e4e4e;
                border-radius: 5px;

              }

            }
          }

        }
      }
      ::v-deep .canvas-tool-bar{
        height: 30px;
        border-top: 1px solid #e4e7ed;
        padding: 0 50px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: #79809a;
        font-size: 20px;
        .scale-number{
          font-size: 12px;
          margin-right: 10px;
        }
        .icon{
          cursor: pointer;
        }
        .el-slider{
          height: 30px;
          width: 200px;
          margin: 0 10px;
          .el-slider__runway{
            margin: 12px 0;
          }
        }
      }
    }

    // 组件设置、大屏设置
    .config-pane{
      width: 420px;
      flex-shrink: 0;
      padding: 20px 0 0 20px;
      background: #f5f5f5;
      @media screen and (max-width: 1600px) {
        width: 350px;
      }
    }
  }
  .preview-dialog{
    :deep(.el-dialog){
      width: 70%;
      margin-top: 7vh !important;
      .el-dialog__body{
        font-size: 0;
      }
    }
    .preview-container{
      width: 100%;
    }
  }
  :deep(.handle){
    width:10px !important;
    height:10px !important;
    border-radius: 50px;
  }
  .contextmenu {
    background: #fff;
    z-index: 3000;
    position: fixed;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #303133;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  }

  .contextmenu li {
    padding: 7px 16px;
    cursor: pointer;
  }

  .contextmenu li:hover {
    background-color: #dcdfe6;
  }
}
</style>
